angular.module('impactx.search').component('ixCatalogItem', {
        bindings: {
            catalog: '<'
        },
        require: {
            listCtrl: '^^ixCatalogList'
        },
        controller: 'CatalogItemCtrl',
        controllerAs: 'itemCtrl',
        templateUrl: 'modules/search/templates/catalog-item.html'
    }
);